export const isMessageSender = (message, userId) => {
	return (message.sender || message.created_by) === userId;
};
